import { useTranslations } from "../../contexts/Translation";
import { H2 } from "../Headers/Headings";
import { useState } from "react";
import { useApiData } from "../../contexts/ApiData";
import Button from "../Button/Button";
import Input, { RadioGroup } from "./Input";
import { ConclusionData, OrgGoal, ValidationError } from "../../types";
import ErrorText from "./ErrorText";
import { useImprovementGoal } from "../../contexts/ImprovementGoal";
import { useOrgGoal } from "../../contexts/OrganizationGoal";
import styles from "./FormStyles.module.css";

const GoalConclusionForm = ({ orgGoal, onSuccess }: { orgGoal?: OrgGoal | null; onSuccess?: () => void }) => {
  const t = useTranslations("improvementGoals");
  const { goal, reloadGoal } = useImprovementGoal();
  const { reloadGoal: reloadOrgGoal } = useOrgGoal();
  const { patch } = useApiData();
  const [errors, setErrors] = useState<ValidationError[]>([]);
  const initialData: ConclusionData = {
    id: orgGoal?.id || goal?.id || "",
    result: orgGoal?.result || goal?.result || "",
    isSuccess: orgGoal?.isSuccess || goal?.isSuccess || "",
  };
  const [formData, setFormData] = useState<ConclusionData>(initialData);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
    setErrors(errors.filter((err) => err.name !== e.target.name));
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const result = await patch(orgGoal ? `/organization-goal/${formData.id}` : `/goals/${formData.id}`, formData);
    if (!result) {
      setErrors([{ name: "form", message: t("serverError") }]);
    } else {
      if (orgGoal) {
        await reloadOrgGoal();
      } else {
        await reloadGoal();
      }
      onSuccess?.();
    }
  };

  return (
    <div>
      <H2>{t("conclusionHeading")}</H2>
      <form className={styles.form} onSubmit={handleSubmit}>
        {errors.filter((e) => e.name !== "form").length > 0 && <ErrorText variant='form' text={t("formErrors")} />}
        <ErrorText variant='form' error={errors.find((e) => e.name === "form")} />

        <RadioGroup
          name='isSuccess'
          handleChange={handleChange}
          label={t("isSuccessLabel")}
          helpText={t("help.goalIsSuccessHelp")}
          value={formData.isSuccess}
          options={[
            { value: "yes", text: t("isSuccessYes") },
            { value: "no", text: t("isSuccessNo") },
          ]}
        />

        <Input type='textarea' name='result' helpText={t("help.goalResult")} handleChange={handleChange} label={t("result")} value={formData.result} />

        <Button>{t("submitConclusion")}</Button>
      </form>
    </div>
  );
};

export default GoalConclusionForm;
